<template>
  <div class="div1 cutbox">

      <div class="text1" data-id="主标题1">
        <span>{{ info.titles[0] }}</span>
      </div>
      <div class="text2" data-id="副标题1" data-range="6,10">
        <span>{{ info.titles[1] }}</span>
      </div>
      <div class="text3">
        <span data-id="短特点1" data-range="2,3">{{ info.specialty_short[0] }}</span>
        <span data-id="短特点2" data-range="2,3">{{ info.specialty_short[1] }}</span>
        <span data-id="短特点3" data-range="2,3">{{ info.specialty_short[2] }}</span>
        <span data-id="短特点4" data-range="2,3">{{ info.specialty_short[3] }}</span>
        <span data-id="短特点5" data-range="2,3">{{ info.specialty_short[4] }}</span>
      </div>

    <div class="text4">
      <img :src="info.image" alt="">
    </div>

      <div class="text5" data-id="长特点1" data-range="11,18">{{ info.specialty[0] }}</div>
      <div class="text6" data-id="公司" data-range="8,37">{{ info.company }}</div>

  </div>
</template>
<script>
export default {
  name: 'TUWEN001',
  props: {
    info: Object
  },
}
</script>
